module.exports = __webpack_public_path__ + "img/sailvan.8c837e31.png";